import styles from '../../styles.module.scss';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Language } from 'providers/translates/enums';
import { isVac } from "utilities/is-vac";
import { Helmet } from 'react-helmet-async';

import { REFLECTING_LIST_ITEMSMemorila, REFLECTING_LIST_ITEMS0,REFLECTING_LIST_ITEMS1,REFLECTING_LIST_ITEMS2 } from './constants';
import { useTranslates } from 'providers/translates';
import MarkdownRenderer from 'components/MarkdownRenderer';

const translationsHelmet = {
  titleEN: 'Saluting Service - Create a quilt square - Step 1',
  titleFR: 'Saluons leur service - Créer un carreau de courtepointe - Étape 1'
} as const;

export const ReflectingSection: React.FC = () => {
  const { translates,selectedLang } = useTranslates();
  const reflectionIntroText = translates?.quiltBuilderStepOne?.reflectionIntroText;
  const accordionSections = translates?.quiltBuilderStepOne?.accordionSections;
  
  return (
    <>
    {isVac() && (
      <Helmet>
        <title>{selectedLang === Language.FRENCH ? translationsHelmet?.titleFR : translationsHelmet?.titleEN}</title>
      </Helmet>
    )}
    {isVac() ? (
      <>
      <div className={styles.accordions}>      
        <h2 className="defaultTitle">{reflectionIntroText?.reflectionHeading ?? 'Reflecting on the person you are honouring'}</h2>
        <p className={styles['reflecting-end']}>
          {reflectionIntroText?.reflectionText ?? (
            <>
             You may be creating a quilt square to honour your own service, or the service of another Veteran who may be living or has died. Before you create your square, explore the prompts below to help you think about what to include in your square.
            </>
          )}
        </p>
        <Accordion className={styles.accordion}>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel0-content"
            sx={{ padding: '0' }}
          >
            <h2 className={styles.accordionTitle}>
              {accordionSections?.accordionOneHeading ?? 'Developing a quilt square to salute your own service:'}
            </h2>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: '8px 16px 16px 0'}}>
            {accordionSections?.accordionOneText ? (
              <MarkdownRenderer 
                content={accordionSections?.accordionOneText}
              />
            ) : (
              <>
                <p className={styles['reflecting-start']}>
                  You may want to take some time to think about:
                </p>
                <ul className='colorNavy'>
                  {REFLECTING_LIST_ITEMS0.map((item, index) => {
                    return (
                      <li className={styles.list_item} key={index}>
                        <span className={styles.list_dot}></span>
                        <span>
                          {item}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </>
            )}                
          </AccordionDetails>
        </Accordion>
        <Accordion className={styles.accordion}>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel0-content"
            sx={{ padding: '0'}}
          >
            <h2 className={styles.accordionTitle}>
              {accordionSections?.accordionTwoHeading ?? 'Developing a quilt square to salute the service of a living Veteran:'}
            </h2>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: '8px 16px 16px 0'}}> 
            {accordionSections?.accordionTwoText ? (
              <MarkdownRenderer 
                content={accordionSections?.accordionTwoText}
              />
            ) : (
              <>
                <p className={styles['reflecting-start']}>
                  Take some time to think about:
                </p>
                <ul className='colorNavy'>
                  {REFLECTING_LIST_ITEMS1.map((item, index) => {
                    return (
                      <li className={styles.list_item} key={index}>
                        <span className={styles.list_dot}></span>
                        <span>
                          {item}
                        </span>
                      </li>
                    );
                  })}
                </ul>   
              </>
            )}       
          </AccordionDetails>
        </Accordion>
        <Accordion className={styles.accordion}>
          <AccordionSummary
            aria-controls="panel0-content"
            expandIcon={<ArrowDropDownIcon />}
            sx={{ padding: '0'}}
          >
            <h2 className={styles.accordionTitle}>
              {accordionSections?.accordionThreeHeading ?? 'Developing a quilt square to salute the service of a Veteran who has died:'}
            </h2>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: '8px 16px 16px 0'}}>
            {accordionSections?.accordionThreeText ? (
              <MarkdownRenderer 
                content={accordionSections?.accordionThreeText}
              />
            ) : (
              <>
                <p className={styles['reflecting-start']}>
                  Take some time to think about:
                </p>
                <ul className='colorNavy'>
                  {REFLECTING_LIST_ITEMS2.map((item, index) => {
                    return (
                      <li className={styles.list_item} key={index}>
                        <span className={styles.list_dot}></span>
                        <span>
                          {item}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
      </>
    ) : (
      <>
      <h2 className="defaultTitle">Reflecting on the person you are honouring</h2>
      <p className={styles['reflecting-start']}>Before you create the memorial, you may want to take some time to think about:</p>
      <ul className='colorNavy'>
        {REFLECTING_LIST_ITEMSMemorila.map((item, index) => {
            return (
              <li className={styles.list_item} key={index}>
                <span className={styles.list_dot}></span>
                <span>
                  {item}
                </span>
              </li>
            );
          })}
      </ul>
      <p className={styles['reflecting-start']}>You may find creating this memorial quilt square brings up many memories, thoughts and feelings you may or may not have expected. Take your time. There is no rush. There may be those you invite to share in its creation who choose not to and that’s OK. You can always add to or remove things even after the memorial quilt square has been posted. Many have found the experience of honouring and remembering the person in this way helpful in their grieving, but not everyone grieves in the same way.</p>
      </>
    )
  }
  </>
);
}
